import { TemplateBi } from "../../models/business-intelligence/template-bi.model";

export class TemplateBiRequest
{
    public listBiReport: number[];
    public templateBi: TemplateBi;
    public isUpdate: boolean;
}